<template>
  <div class="appointment-time-component">
    <div v-if="selectedDate" class="event-details">
      <div class="event">
        <div class="d-flex">
          <i class="far fa-calendar-alt me-3"></i>
          <div class="content">
            <p class="pt-1">
              <strong>{{ selectedDate.id | formatDate }}</strong><br>
            </p>
          </div>
        </div>
      </div>

    </div>
    <div class="form-group form-label-group">
      <select v-model="selectedTime" class="form-control" name="time" id="time" @click="selectedDevelopmentId === null ? alert('Select a development first') : (selectedDate === null ? alert('Select a date first') : '')">
        <option :value="null">Select Time</option>
        <option v-for="time in appointmentTimes" :key="time" :value="time">
          {{ time }}
        </option>
      </select>
      <label for="time">Appointment time</label>
    </div>
    <button v-if="selectedTime" class="btn btn-primary mb-3" @click="addAppointmentTime" type="button">
      Add Appointment Time
      <i class="far fa-plus"></i>
    </button>
    <p><small>Appointments last for one hour. If a longer appointment is needed then a member of the Castle Green team will be in touch.</small></p>
    <div v-if="selectedDateTimes && selectedDateTimes.length > 0" class="mt-3 event-details">
      <div v-for="(selectedDateTime, idx) in selectedDateTimes" :key="selectedDateTime.id" class="event" @click="removeAppointmentTime(idx)">
        <div class="d-flex">
          <i class="far fa-calendar-alt me-3"></i>
          <div class="content">
            <p class="pt-1">
              <strong>{{ selectedDateTime | moment("L - LT") }}</strong>
            </p>
          </div>
        </div>
      </div>
      <p v-if="selectedDateTimes && selectedDateTimes.length < 3"><strong>
        Please request at least 3 different appointment times, in order of preference. Click on an appointment time to remove it.
      </strong></p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appointmentTimes: null,
      selectedDate: null,
      loading: false,
      selectedTime: null,
      selectedDateTimes: [],
      selectedDevelopmentId: null,
    };
  },
  props: {
    developmentId: {
      type: [Number],
      default: null,
    },
    existingAppointmentTimes: {
      type: [Array],
      default: null,
    },
  },
  mounted() {
    this.$root.$on('getAppointmentTimes', this.getAppointmentTimes);
    this.$root.$on('updateDevelopmentId', this.updateDevelopmentId);
    this.selectedDevelopmentId = this.developmentId;

    if (this.existingAppointmentTimes) {

      for (let i = 0; i < this.existingAppointmentTimes.length; i++) {
        this.selectedDateTimes.push(new Date(this.existingAppointmentTimes[i]));
      }
      this.updateRequestedDateTimes();
    }
  },

  methods: {
    alert(message) {
      alert(message);
    },
    getAppointmentTimes(date) {
      this.loading = true;
      this.selectedDate = date;

      if (this.selectedDevelopmentId && this.selectedDate) {
        axios.post(window.api_url + '/appointments/times', {
          date: this.selectedDate.id,
          development_id: this.selectedDevelopmentId,
        })
          .then(res => {
            if (res.data && res.data.success) {
              this.appointmentTimes = res.data.times;
            }
          })
          .catch(err => {
            //
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.loading = false;
        this.appointmentTimes = null;
        this.selectedTime = null;
      }
    },
    updateDevelopmentId(developmentId) {
      this.selectedDevelopmentId = developmentId;
      this.getAppointmentTimes(this.selectedDate);
    },
    addAppointmentTime() {
      // check if date time already exists
      let exists = false;
      for (let i = 0; i < this.selectedDateTimes.length; i++) {
        if (this.selectedDateTimes[i].getTime() === new Date(this.selectedDate.id + ' ' + this.selectedTime).getTime()) {
          exists = true;
          break;
        }
      }

      if (this.selectedTime && !exists) {
        let dateTime = new Date(this.selectedDate.id + ' ' + this.selectedTime);
        this.selectedDateTimes.push(dateTime);
        this.updateRequestedDateTimes();
      }
    },
    removeAppointmentTime(idx) {
      this.selectedDateTimes.splice(idx, 1);
      this.updateRequestedDateTimes();
    },
    updateRequestedDateTimes() {
      // update div id requestedDateTimes content with multiple hidden form inputs
      let requestedDateTimes = document.getElementById('requestedDateTimes');
      requestedDateTimes.innerHTML = '';
      for (let i = 0; i < this.selectedDateTimes.length; i++) {
        let date = this.selectedDateTimes[i];
        let input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'requested_datetimes[]');
        // set iso datetime adjusting for BST if necessary
        input.setAttribute('value', new Date (date.valueOf() - (date.getTimezoneOffset() * 60000)).toISOString().slice(0, 19).replace("T", " "));
        requestedDateTimes.appendChild(input);
      }

      let submit =  document.getElementById('appointment-submit');
      if (this.selectedDateTimes.length < 3) {
        // add d-none class
        if (!submit.classList.contains('d-none')) {
          submit.classList.add('d-none');
        }
      } else {
        // remove d-none class
        if (submit.classList.contains('d-none')) {
          submit.classList.remove('d-none');
        }

      }
    },
  },
};
</script>
